export function asc(a, b) {
  return a - b;
}